import React from "react";
import Footer from "../../../components/footer";
import PersonalDetails from "../../../components/PersonalDetails";
import EmailAddress from "../../../components/EmailAddress";
import ProfilePhoneNumber from "../../../components/ProfilePhoneNumber";
import MailingAddress from "../../../components/MailingAddress";
import EmergencyContact from "../../../components/EmergencyContact";
import { useUserProfile } from "../../../hooks/getUserProfile";

const ProfilePersonalDetails = () => {
  const { data: userProfile, isLoading, error, refetch } = useUserProfile();

  return (
    <div className="noScroll h-90 verticalScroll pb-17">
      <PersonalDetails
        userProfile={userProfile?.data}
        isLoading={isLoading}
        refetch={refetch}
      />
      <EmailAddress
        userProfile={userProfile?.data}
        isLoading={isLoading}
        refetch={refetch}
      />
      <ProfilePhoneNumber
        userProfile={userProfile?.data}
        isLoading={isLoading}
        refetch={refetch}
      />
      <MailingAddress
        userProfile={userProfile?.data}
        isLoading={isLoading}
        refetch={refetch}
      />
      <EmergencyContact
        userProfile={userProfile?.data}
        isLoading={isLoading}
        refetch={refetch}
      />
    </div>
  );
};

export default ProfilePersonalDetails;
